<!--基于v-charts和echarts的水球图-->
<template>
  <div class="chart">
    <ve-liquidfill
      height="100%"
      :extend="chartExtends"
      :loading="loading"
    />
  </div>
</template>
<script>
import echarts from 'echarts'
export default {
  props: {
    columns: Array,
    data: Number,
    setting: Object,
    extend: Object,
    loading: Boolean
  },
  data () {
    return {
      chartData: {
        columns: this.columns,
        rows: this.data
      }
    }
  },
  computed: {
    chartSettings () {
      const setting = this.setting || {}
      const o = {

      }
      Object.assign(o, setting)
      return o
    },
    chartExtends () {
      /**
       * 此处配置参考echart的配置项
      */
      // 获取圆上面某点的坐标(x0,y0表示坐标，r半径，angle角度)
      function getCirlPoint (x0, y0, r, angle) {
        const x1 = x0 + r * Math.cos((angle * Math.PI) / 180)
        const y1 = y0 + r * Math.sin((angle * Math.PI) / 180)
        return {
          x: x1,
          y: y1,
        }
      }
      var color = new echarts.graphic.RadialGradient(0.5, 0.5, 1, [{
        offset: 0,
        color: '#4978EC'
      },
      {
        offset: 0.5,
        color: '#1E2B57'
      },
      {
        offset: 1,
        color: '#141F3D'
      }
      ], false)
      const extend = this.extend || {}
      const angle = -90
      const value = 300
      var o = {
        series: [
          {
            type: 'liquidFill',
            radius: '65%',
            center: ['50%', '50%'],
            data: [this.data.toFixed(2)], // data个数代表波浪数
            color: ['#388CF4'],
            backgroundStyle: {
              color: color
            },
            tooltip: {
              show: false
            },
            label: {
              normal: {
                formatter: (this.data * 100).toFixed(2) + '%',
                textStyle: {
                  fontSize: 22,
                  color: '#f6f6f6'
                },
              },
            },
            outline: {
              show: false,
            },
          },
          {
            name: 'ring',
            type: 'custom',
            coordinateSystem: 'none',
            renderItem: function (params, api) {
              return {
                type: 'arc',
                shape: {
                  cx: api.getWidth() / 2,
                  cy: api.getHeight() / 2,
                  r: (Math.min(api.getWidth(), api.getHeight()) / 2) * 0.8,
                  startAngle: ((0 + angle) * Math.PI) / 180,
                  endAngle: ((value + angle) * Math.PI) / 180,
                },
                style: {
                  stroke: '#8383FA',
                  fill: 'transparent',
                  lineWidth: 1.5,
                },
                silent: true,
              }
            },
            data: [0],
          },
          {
            name: 'circle', // 紫点
            type: 'custom',
            coordinateSystem: 'none',
            renderItem: function (params, api) {
              const x0 = api.getWidth() / 2
              const y0 = api.getHeight() / 2
              const r = (Math.min(api.getWidth(), api.getHeight()) / 2) * 0.8
              const point = getCirlPoint(x0, y0, r, value + angle)
              return {
                type: 'circle',
                shape: {
                  cx: point.x,
                  cy: point.y,
                  r: 6,
                },
                style: {
                  stroke: '#8450F9', // 绿
                  fill: '#8450F9',
                },
                silent: true,
              }
            },
            data: [0],
          },
        ],
      }

      Object.assign(o, extend)
      return o
    }
  },
  watch: {
    data: {
      handler: function (val) {
        this.chartData.rows = val
      },
      deep: true // 对象内部的属性监听，也叫深度监听
    },
    columns (val) {
      this.chartData.columns = val
    }
  }
}
</script>
<style lang="stylus" scoped>
/deep/.v-charts-data-empty
  background-color: #1C2550
  color #1cc197
  font-size 16px
.chart
  height 100%
  width 100%
</style>
